import React from 'react';
import { useNavigate } from 'react-router-dom';
import PartnersView from './view';

const PartnersContainer = ({ venues, onVenueClick, communitySlug }) => {
    const navigate = useNavigate();

    const handleVenueClick = (venue) => {
        const venueSlug = venue.venue?.slug;
        if (venueSlug) {
            navigate(`/venue/${venueSlug}`);
        }

    };

    return (
        <PartnersView
            venues={venues || []}
            onVenueClick={handleVenueClick}
        />
    );
};

export default PartnersContainer;